export default __webpack_public_path__ + "static/media/sync_404.6d5a24cd.webp";